import React from 'react';
import {
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col
} from 'framework7-react';

import { PrimaryLogo, MerchantSvg, BikeSvg } from '../components/crumbs';

// _helper
import { toast, isEmpty, isValidEmail, uploadFile } from '../utils/_helpers';

import { Doc } from '../utils/_classes';
import moment from 'moment';
// Redux
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withFirestore, withStorage, firestoreConnect } from '../HOCs';

class DeclinedApplication extends React.Component {
  constructor(props) {
    super(props);
    var declinedVendor = props.f7route.params.id;

    this.state = {
      popupOpened: false,
      popupDataChanged: true,
      type: declinedVendor
    };
  }

  render() {
    return (
      <Page id="decline-page" onPageAfterIn={this.onPageAfterIn.bind(this)}>
        <Navbar sliding={false} backLink="Back">
          <NavTitle sliding>Application Declined</NavTitle>
        </Navbar>

        <Block>
          <h1>Application Declined</h1>
          <Row>
            <Col>
              <Card style={{ margin: 'auto' }} className="easyPrintText">
                <CardHeader className="no-border">Request Details</CardHeader>
                <CardContent>
                  {/* Leave this tags */}
                  <strong>
                    See the following instruction below as to why your
                    application was rejected:
                  </strong>
                  <p>
                    Please ensure that the following requirements are available
                    before clicking on the Re-apply button below:
                  </p>
                  {/* Leave this tags */}

                  {/* show reasons below why admin rejected application */}
                  <div className="declineMessage">
                    {this.state.type === '1'
                      ? !this.props.data.loading &&
                        this.props.data.merchants &&
                        this.props.data.merchants[this.props.auth.uid] &&
                        this.props.data.merchants[this.props.auth.uid]
                          .reason && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: this.props.data.merchants[
                                this.props.auth.uid
                              ].reason.message
                            }}></div>
                        )
                      : this.state.type === '2' ? !this.props.data.loading &&
                        this.props.data.delivery &&
                        this.props.data.delivery[this.props.auth.uid] &&
                        this.props.data.delivery[this.props.auth.uid]
                          .reason && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: this.props.data.delivery[
                                this.props.auth.uid
                              ].reason.message
                            }}></div>
                        ) : !this.props.data.loading &&
                        this.props.data.partners &&
                        this.props.data.partners[this.props.auth.uid] &&
                        this.props.data.partners[this.props.auth.uid]
                          .reason && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: this.props.data.partners[
                                this.props.auth.uid
                              ].reason.message
                            }}></div>
                        )}
                  </div>
                </CardContent>
                <CardFooter>
                  <Row style={{ width: '100%' }}>
                    <Col width="100" medium="50" style={{ marginTop: '10pt' }}>
                      {/* Include timestamp from message  */}
                      <pre>
                        Reviewed:{' '}
                        {this.state.type === '1'
                          ? !this.props.data.loading &&
                            this.props.data.merchants &&
                            this.props.data.merchants[this.props.auth.uid] &&
                            this.props.data.merchants[this.props.auth.uid]
                              .reason && (
                              <small>
                                {moment(
                                  this.props.data.merchants[this.props.auth.uid]
                                    .reason.timestamp
                                ).format('DD MMMM YYYY, h:mm a')}
                              </small>
                            )
                          : this.state.type === '2' ? !this.props.data.loading &&
                            this.props.data.delivery &&
                            this.props.data.delivery[this.props.auth.uid] &&
                            this.props.data.delivery[this.props.auth.uid]
                              .reason && (
                              <small>
                                {moment(
                                  this.props.data.delivery[this.props.auth.uid]
                                    .reason.timestamp
                                ).format('DD MMMM YYYY, h:mm a')}
                              </small>
                            ): !this.props.data.loading &&
                            this.props.data.partners &&
                            this.props.data.partners[this.props.auth.uid] &&
                            this.props.data.partners[this.props.auth.uid]
                              .reason && (
                              <small>
                                {moment(
                                  this.props.data.partners[this.props.auth.uid]
                                    .reason.timestamp
                                ).format('DD MMMM YYYY, h:mm a')}
                              </small>
                            ) }
                      </pre>
                    </Col>
                    <Col width="100" medium="50" style={{ marginTop: '10pt' }}>
                      <Button
                        round
                        fill
                        href={
                          this.state.type === '1'
                            ? '/business-registration/1/'
                            : this.state.type === '2' ? '/business-registration/2/' : '/business-registration/3/'
                        }>
                        Re-Apply
                      </Button>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Block>
      </Page>
    );
  }

  // Events
  onPageAfterIn(){
    this.$f7.methods.showFullText() 
  }
}

const mapStateToProps = ({ firebase: { auth }, DB: { docs } }) => ({
  auth,
  data: docs
});

const enhance = compose(
  withStorage,
  withFirestore,
  firestoreConnect(props => [new Doc('merchants', props.auth.uid), new Doc('delivery', props.auth.uid), new Doc('partners', props.auth.uid)]),
  connect(mapStateToProps)
);

export default enhance(DeclinedApplication);
